export default "__VITE_ASSET__cd1122b9__"